import gql from "graphql-tag";

export const importPersonSubjectEnrollment = gql`
    mutation ImportPersonSubjectEnrollment(
        $data: [ImportPersonSubjectEnrollmentInput]
    ){
        importPersonSubjectEnrollment(data: $data)
    }
`;
